import React, { useState } from 'react';
import { 
    TextField, Button, Typography, Card, InputAdornment,
    Box, FormControl, FormLabel, FormControlLabel, Link, Checkbox, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import {Visibility, VisibilityOff} from '@mui/icons-material'

import {
    user_login_event
} from '../../services/login_system'
import * as CONSTANTS from '../../constants'

const LoginForm = ({lang, onClose, updateAuth, setLoginMode }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [passwordError, setPasswordError] = useState(false);
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [remember, setRemember] = useState(false);

    const [isValidLogin, setIsValidLogin] = useState(false);

    const handleShowPassword = () => setShowPassword(!showPassword);
    const handleRememberMe = (event) => {
        setRemember(event.target.checked);
    };

    const switchToSignUpMode = () => {
        setLoginMode('Sign Up');
    }

    const switchToResetPasswordMode = () => {
        setLoginMode('Reset Password');
    }

    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!isValidLogin){
            return;
        }
    
        const [status, result] = await user_login_event(
            email,
            password,
            remember,
        );

        // success login
        if (status === 200) {
            const username = result.username;
            const email = result.email; 
            updateAuth(username, email); // Close the dialog on submit
            onClose();
        } 
        // failed login
        else {
            setPasswordError(true);
            setPasswordErrorMessage(CONSTANTS.LOGIN_FORM.ERROR_MESSAGE.INCORRECT_EMAIL_OR_PASSWORD[lang]);
        }
    };

    const validateInputs = () => {
        const user_email = document.getElementById('email');
        const user_password = document.getElementById('password') ;

        let isValid = true;

        if (!user_email.value || !/\S+@\S+\.\S+/.test(user_email.value)) {
            setEmailError(true);
            setEmailErrorMessage(CONSTANTS.LOGIN_FORM.ERROR_MESSAGE.ENTER_VALID_EMAIL[lang]);
            isValid = false;
        } else {
            setEmailError(false);
            setEmailErrorMessage('');
        }


        setEmail(user_email.value);
        setPassword(user_password.value);

        setIsValidLogin(isValid);

        return isValid;
    };

    return (
        <Card
            sx={{
                width: '25vw',
                padding: '3vw',
                minWidth: "300px",
            }}
        >
            <div>
                <Typography
                    component="h1"
                    variant="h4"
                    fontWeight='bold'
                    sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
                    mb={3}
                >
                    {CONSTANTS.APP_BAR.LOGIN[lang]}
                </Typography>
                <IconButton
                    onClick={() => onClose()}
                    sx={{
                        position: 'absolute',
                        right: 1,
                        top: 1,
                    }}
                    tabIndex="7"
                >
                    <CloseIcon/>
                </IconButton>
            </div>
            
            <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    gap: 2,
                }}
            >
                <FormControl>
                    <FormLabel htmlFor="email">{CONSTANTS.LOGIN_FORM.EMAIL[lang]}</FormLabel>
                    <TextField
                        error={emailError}
                        helperText={emailErrorMessage}
                        id="email"
                        type="email"
                        name="email"
                        placeholder="your@email.com"
                        autoComplete="email"
                        autoFocus
                        required
                        fullWidth
                        variant="outlined"
                        color={emailError ? 'error' : 'primary'}
                        slotProps={{htmlInput: {tabIndex: "0"}}}
                        sx={{ ariaLabel: 'email' }}
                    />
                </FormControl>
                <FormControl>
                    <Box 
                        sx={{ display: 'flex', justifyContent: 'space-between' }} 
                    >
                        <FormLabel htmlFor="password">{CONSTANTS.LOGIN_FORM.PASSWORD[lang]}</FormLabel>
                        <Link
                            component="button"
                            onClick={() => switchToResetPasswordMode()}
                            variant="body2"
                            sx={{ alignSelf: 'baseline' }}
                            tabIndex="5"
                        >
                        {CONSTANTS.LOGIN_FORM.FORGOT_YOUR_PASSWORD[lang]}
                        </Link>
                    </Box>
                <TextField
                    error={passwordError}
                    helperText={passwordErrorMessage}
                    name="password"
                    placeholder="••••••"
                    type={showPassword ? "text" : "password"}
                    id="password"
                    autoComplete="current-password"
                    required
                    fullWidth
                    variant="outlined"
                    color={passwordError ? 'error' : 'primary'}
                    slotProps={{htmlInput: {tabIndex: "1"}}}
                    InputProps={{ // <-- This is where the toggle button is added.
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => handleShowPassword()}
                                tabIndex="2"
                            >
                              {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        )
                    }}
                />
                </FormControl>
                <FormControlLabel
                    control={
                        <Checkbox 
                            value="remember" 
                            color="primary" 
                            tabIndex="3"
                            checked={remember}
                            onChange={handleRememberMe}
                        />
                    }
                    label={CONSTANTS.LOGIN_FORM.REMEMBER_ME[lang]}
                />
                {/* <ForgotPassword open={open} handleClose={handleClose} /> */}
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    tabIndex="4"
                    onClick={() => validateInputs()}
                >
                {CONSTANTS.APP_BAR.LOGIN[lang]}
                </Button>
                <Typography sx={{ textAlign: 'center' }}>
                {CONSTANTS.LOGIN_FORM.DONT_HAVE_ACCOUNT[lang]+' '}
                <span>
                    <Link
                        variant="body2"
                        sx={{ alignSelf: 'center' }}
                        onClick={() => switchToSignUpMode()}
                        tabIndex="6"
                    >
                    {CONSTANTS.APP_BAR.REGISTER[lang]}
                    </Link>
                </span>
                </Typography>
            </Box>
        </Card>
    );
};

export default LoginForm;
